export default __webpack_public_path__ + "static/media/4.3b6d7b9d.svg";